import React from "react";

// CustomButtonのcomponentスロットを使い、既存の外部YouTubeリンク属性を保つ。
export const ExternalVideoAnchor = React.forwardRef<HTMLAnchorElement, React.AnchorHTMLAttributes<HTMLAnchorElement>>(
  (props, ref) => <a {...props} ref={ref} target="_blank" rel="noopener noreferrer" />
);

ExternalVideoAnchor.displayName = "ExternalVideoAnchor";
